export function getSiteDetailsKey(siteId: string | number) {
  return `site-details-${siteId}`;
}
